import { useState, ReactNode, useRef } from 'react'
import cl from 'classnames'
import { BsPlus } from 'react-icons/bs'
import { AiOutlineMinus } from 'react-icons/ai'
import { Title } from '@components/v2/title'

import styles from './styles.module.scss'

interface CollapsibleItemProps {
  question?: string
  children?: ReactNode
  className?: string
  customQuestionComponent?: ReactNode
}

export const CollapsibleItem = ({
  question,
  children,
  className
}: CollapsibleItemProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const parentRef = useRef<HTMLDivElement>()

  return (
    <div className={cl({ 'flex flex-col gap-4 md:gap-6': isOpen }, className)}>
      <div className={styles.headerQuestion} onClick={() => setIsOpen(!isOpen)}>
        <Title className={styles.questionText} level="h3">
          {question}
        </Title>
        {isOpen ? (
          <AiOutlineMinus className={styles.icon} />
        ) : (
          <BsPlus className={styles.icon} />
        )}
      </div>
      <div
        className={styles.wrapperContent}
        ref={parentRef}
        style={{
          height: isOpen ? parentRef?.current?.scrollHeight + 'px' : '0px'
        }}
      >
        <div>{children}</div>
      </div>
    </div>
  )
}
